<script setup lang="ts">
import axios from '@/api/axios';
import { ref, watch } from 'vue';
import UserSearch from './UserSearch.vue';
import Participant from '@/stores/communication/Participant';

const props = defineProps<{ show: boolean }>();
const emit = defineEmits(['update:show', 'created']);

const show = ref(props.show || false);
const type = ref<'direct' | 'group'>('direct');
const name = ref('');
const participants = ref<Participant[]>([]);
const loading = ref(false);

watch(
	() => props.show,
	(v) => (show.value = v)
);

watch(show, (v) => emit('update:show', v));

async function create() {
	if (!participants.value.length) return;
	loading.value = true;
	try {
		const payload = {
			type: type.value,
			name: name.value,
			participants: participants.value.map((participant) => participant.id),
		};
		const res = await axios.post('/chat/conversations', payload);
		emit('created', res.data);
		show.value = false;
	} catch (e) {
		console.error(e);
	} finally {
		loading.value = false;
	}
}

function close() {
	show.value = false;
}
</script>
<template>
	<v-dialog v-model="show" max-width="600">
		<v-card>
			<v-card-title> Create Conversation </v-card-title>

			<v-card-text>
				<v-form ref="formRef" @submit.prevent="create">
					<v-radio-group v-model="type">
						<v-radio label="Direct (1:1)" value="direct" />
						<v-radio label="Group" value="group" />
					</v-radio-group>

					<v-text-field
						v-if="type === 'group'"
						v-model="name"
						label="Group name"
					/>

					<UserSearch v-model:selection="participants" />

					<v-card-actions>
						<v-spacer />
						<v-btn @click="close">Cancel</v-btn>
						<v-btn color="teal" type="submit" :loading="loading">Create</v-btn>
					</v-card-actions>
				</v-form>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
